import { useQuery } from "@tanstack/react-query";
import { useAddInState } from "@/components/AddInStateProvider";
import { useGeotabClient } from "@/components/GeotabClientContext";
import createGroupFilter from "@/utilities/createGroupFilter";

/**
 * Returns the device with the given id.
 *
 * @param id - The id of the device.
 * @returns - The {@link Device}.
 */
export function useDeviceById(id?: string, interval?: number) {
  const { geotabClient, activeSessionId } = useGeotabClient();
  const { groups, groupFilterCondition } = useAddInState();

  return useQuery({
    queryKey: ["device", activeSessionId, id],

    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.resolve(null);
      }
      const filter = createGroupFilter(groups, groupFilterCondition, { id });

      return geotabClient.get("Device", filter, 1, signal).then(devices => devices[0] ?? null);
    },

    refetchInterval: interval ?? 120000,
  });
}
